import styled from 'styled-components';

export const Nav = styled.nav`
  display: flex;
  border-bottom: 1px solid #979797;
  background: #fff;
`;

export const Content = styled.div``;
